module.exports = __webpack_public_path__ + "img/woman123.dde32288.png";